import React from 'react';
import { Alert, Empty, Spin, Typography } from 'antd';

import type { InspectAssessmentInstrument } from '../../../../state/app/inspect_assessment/types';

type Props = {
  instruments: InspectAssessmentInstrument[];
  fetching: boolean;
  error?: string;
  selectedAssessmentId?: number;
  selectedInstrumentId?: number;
  onSelectInstrument: (instrumentId: number) => void;
};

const InstrumentSidecar: React.FC<Props> = ({
  instruments,
  fetching,
  error,
  selectedAssessmentId,
  selectedInstrumentId,
  onSelectInstrument,
}) => (
  <aside className="assessment-inspect-assessment__sidecar">
    <div className="assessment-inspect-assessment__sidecar-heading">
      <span>Assessed instruments</span>
      {selectedAssessmentId !== undefined && !fetching && (
        <Typography.Text type="secondary">
          {instruments.length}
        </Typography.Text>
      )}
    </div>
    <div className="assessment-inspect-assessment__instrument-list">
      {fetching ? (
        <div className="assessment-inspect-assessment__centered">
          <Spin size="small" />
        </div>
      ) : error ? (
        <Alert type="error" showIcon message="Instruments could not be loaded" />
      ) : selectedAssessmentId === undefined ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Select an assessment to see its instruments"
        />
      ) : instruments.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No assessed instruments"
        />
      ) : (
        instruments.map(instrument => (
          <button
            type="button"
            key={instrument.id}
            className={`assessment-inspect-assessment__instrument-row ${
              instrument.id === selectedInstrumentId
                ? 'assessment-inspect-assessment__instrument-row--active'
                : ''
            }`}
            onClick={() => onSelectInstrument(instrument.id)}
          >
            <span className="assessment-inspect-assessment__instrument-code">
              {instrument.code}
            </span>
          </button>
        ))
      )}
    </div>
  </aside>
);

export default InstrumentSidecar;
